var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';
import { store, useAppDispatch, useAppSelector, } from '../../../store';
import { handleIsOpen } from '../../../store/slices/healthMonitorsSlice';
const isHealthMonitorOpenedSelector = createSelector(_react_refresh_temp_1 = (state) => state.healthMonitor, (healthMonitor) => healthMonitor.isOpen);
$RefreshReg$(_react_refresh_temp_1, "isHealthMonitorOpenedSelector$createSelector");
const HealtMonitorIcon = ({ currentRoom }) => {
    _react_refresh_temp_3();
    const showTooltip = store.getState().session.userDeviceType === 'desktop';
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const isHealthMonitorOpened = useAppSelector(isHealthMonitorOpenedSelector);
    const [iconCSS, setIconCSS] = useState('primaryColor');
    useEffect(() => {
        if (isHealthMonitorOpened) {
            setIconCSS('secondaryColor');
        }
        else {
            setIconCSS('primaryColor dark:text-darkText');
        }
    }, [isHealthMonitorOpened]);
    const toggleHealthMonitor = async () => {
        dispatch(handleIsOpen(!isHealthMonitorOpened));
    };
    const render = () => {
        return (_jsxs("div", { className: `hands footer-icon h-[35px] lg:h-[40px] w-[35px] lg:w-[40px] overflow-hidden rounded-full bg-[#F2F2F2] dark:bg-darkSecondary2 hover:bg-[#ECF4FF] ltr:mr-3 lg:ltr:mr-6 rtl:ml-3 lg:rtl:ml-6 flex items-center justify-center cursor-pointer ${showTooltip ? 'has-tooltip' : ''}`, onClick: () => toggleHealthMonitor(), children: [_jsx("span", { className: "tooltip !bottom-[62px]", children: isHealthMonitorOpened
                        ? t('footer.icons.close-health-monitor')
                        : t('footer.icons.open-health-monitor') }), _jsx("img", { className: 'monitor-icon', src: '../../../assets/imgs/monitor-icon.svg', alt: 'Monitor icon' })] }));
    };
    return render();
};
_react_refresh_temp_2 = HealtMonitorIcon;
$RefreshReg$(_react_refresh_temp_2, "HealtMonitorIcon");
_react_refresh_temp_3(HealtMonitorIcon, "RZj80TlE2Tfp9Z51noXUxLiutkI=", false, () => [useTranslation, useAppDispatch, useAppSelector]);
export default HealtMonitorIcon;
